import React from "react";
import Badge from "shared/Badge/Badge";
import LikeSaveBtns from "./LikeSaveBtns";
import sanitizeHtml from "sanitize-html";

export default function HomeIntro({ venue }: any) {
  const clean = sanitizeHtml(venue!["venue_content"], {});

  return (
    <div className="listingSection__wrap !space-y-6 ">
      {/* 1 */}
      <div className="flex justify-between items-center ">
        <div className="flex justify-between items-center w-2/6">
          <Badge color="blue" name="Pole" />
          <Badge color="pink" name="Hoop" />
          <Badge color="green" name="Hammock" />
          <Badge color="indigo" name="Yoga" />
        </div>
        <LikeSaveBtns />
      </div>

      {/* 2 */}
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">{venue!["venue_name"]}</h2>
      <span className="block mt-2 text-neutral-500 dark:text-neutral-400">{venue!["venue_desc"]}</span>

      {/* 3 */}
      <div className="flex items-center space-x-4">
        {/* <StartRating /> */}
        <span>
          <i className="las la-map-marker-alt"></i>
          <span className="ml-1 text-neutral-500  dark:text-neutral-400">{venue!["venue_location"]}</span>
        </span>
      </div>

      <div className="text-neutral-6000 dark:text-neutral-300">
        <div dangerouslySetInnerHTML={{ __html: venue!["venue_content"] }} />
      </div>
    </div>
  );
}
